import type { AssetLite } from "@/entities/asset";
import type { ReferentialConditionRatingValue } from "@/entities/referential/referential-condition-ratings";

import { useAssetsBatchUpdate } from "@/entities/assets";
import { CONDITION_RATING_NOT_RATED } from "@/entities/referential/referential-condition-ratings";
import { useBatchEditForm } from "@/modules/batch-edit-form";

const fieldName = "condition_rating";
const defaultValue = CONDITION_RATING_NOT_RATED;

export const useAssetsBatchEditConditionRating = (assets: AssetLite[]) => {
  const initialValue: ReferentialConditionRatingValue =
    assets[0]?.[fieldName] ?? defaultValue;

  const { mutate, isPending, status, error } = useAssetsBatchUpdate(assets);

  const onMutateReady = (value: ReferentialConditionRatingValue) => {
    const newValue = value === defaultValue ? null : value;
    mutate({ [fieldName]: newValue });
  };

  const formProps = useBatchEditForm({
    fieldName,
    initialValue,
    onMutateReady,
    status,
    error,
  });

  return {
    ...formProps,
    fieldName,
    initialValue,
    isPending,
  };
};
